import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { default as SiteForm } from "./Components/SiteForm";
import { getSiteById, postSites, updateSiteById } from "../../Services/siteService";
import { getAllUsers } from "../../Services/UserService";
import toast from "react-hot-toast";
import * as routes from "../../routes";
import * as constants from "./constants";
import { extractErrorMessage } from "../../Utils/extractErrorMessage";

const SiteOperations = () => {
  const { siteId } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [siteData, setSiteData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [siteInchargeList, setSiteInchargeList] = useState([]);
  const [projectInchargeList, setProjectInchargeList] = useState([]);

  const mode = pathname.includes("/edit")
    ? constants.EDIT_MODE
    : pathname.includes("/view")
      ? constants.VIEW_MODE
      : constants.ADD_MODE;

  const defaultInitialValues = {
    name: "",
    client: {
      name: "",
      email: "",
      phone: "",
      address: "",
    },
    estimated_start_date: "",
    estimated_end_date: "",
    geofence: null,
    site_incharge: "",
    project_incharge: "",
    is_active: true,
  };

  // Fetch incharge lists
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const [siteUsersRes, projectUsersRes] = await Promise.all([
          getAllUsers({ role: constants.ROLES.INCHARGE }),
          getAllUsers({ role: constants.ROLES.PROJECT_INCHARGE }),
        ]);
        setSiteInchargeList(siteUsersRes.data.results || []);
        setProjectInchargeList(projectUsersRes.data.results || []);
      } catch (err) {
        toast.error(constants.LOAD_INCHARGE_FAILED);
      }
    };

    fetchUsers();
  }, []);

  // Fetch site data if edit/view
  useEffect(() => {
    const fetchData = async () => {
      if (mode === constants.ADD_MODE) {
        setSiteData(defaultInitialValues);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await getSiteById(siteId);
        if (response.status === 200) {
          setSiteData(response.data);
        } else {
          const msg = extractErrorMessage(response) || constants.SITE_NOT_FOUND;
          toast.error(msg);
        }
      } catch (err) {
        const msg = extractErrorMessage(err) || constants.SITE_LOAD_FAILED;
        toast.error(msg);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [mode, siteId]);

  const handleSubmit = async (payload) => {
    try {
      if (mode === constants.ADD_MODE) {
        await postSites(payload);
        toast.success(constants.SITE_CREATE_SUCCESS);
      } else {
        await updateSiteById(siteId, payload);
        toast.success(constants.SITE_UPDATE_SUCCESS);
      }
      navigate(routes.SITE);
    } catch (error) {
      const msg = extractErrorMessage(error) || constants.SITE_SAVE_FAILED;
      toast.error(msg);
    }
  };


  return (
    <div className="relative z-0 max-w-3xl mx-auto px-4 mt-4 mb-6 overflow-visible">
      <SiteForm
        mode={mode}
        initialValues={siteData}
        onSubmit={handleSubmit}
        loading={loading}
        submitText={mode === constants.EDIT_MODE ? "Update Site" : "Create Site"}
        siteInchargeList={siteInchargeList}
        projectInchargeList={projectInchargeList}
      />
    </div>
  );
};

export default SiteOperations;
